import { useEffect, useState } from 'react'
import { useAddressFormat, type AddressFormat } from '@dhl/receiver-address-format-api'
import { ServiceCarrier } from '~/app-constants'

export const useCustomAddressFormat = (countryCode: string) => {
  const addressFormat = useAddressFormat(ServiceCarrier, countryCode)
  const [customAddressFormat, setCustomAddressFormat] = useState<AddressFormat | undefined>()

  useEffect(() => {
    setCustomAddressFormat(
      addressFormat
        ? ({
            ...addressFormat,
            postalCodeFormat: { ...addressFormat.postalCodeFormat, fieldSize: { mobile: 12, desktop: 12 } },
            cityFormat:
              countryCode === 'BE'
                ? {
                    fieldKind: 'Autocomplete',
                    fieldSize: { mobile: 12, desktop: 6 },
                    isRequired: true,
                  }
                : addressFormat.cityFormat,
            houseNumberFormat: { ...addressFormat.houseNumberFormat, fieldSize: { mobile: 6, desktop: 6 } },
            houseNumberSuffixFormat: { ...addressFormat.houseNumberSuffixFormat, fieldSize: { mobile: 6, desktop: 6 } },
          } as AddressFormat)
        : undefined
    )
  }, [addressFormat, countryCode])

  return {
    customAddressFormat,
  }
}
